import React, { useEffect, useRef, useState } from "react";
import formBaseStyles from "../../text-input/styles.module.scss";
import styles from "../styles.module.scss";
import CaretDown from "../../../../assets/svg/icons/common/CaretDown";
import SearchIcon from "../../../../assets/svg/icons/common/search";
import TextInput from "../../text-input";
import BlueTick from "../../../../assets/svg/icons/common/blue-tick";

const Option = ({ children, option, handleOptionSelect, selected }) => {
  return (
    <div
      tabIndex={0}
      className={`${styles.option} ${selected && styles.selected}`}
      onClick={() => handleOptionSelect(option)}
      onKeyUp={(e) => e.key === "Enter" && handleOptionSelect(option)}
    >
      {children}
    </div>
  );
};

const UserItem = ({ option, selected }) => {
  return (
    <div className={styles.userItem}>
      {selected && (
        <div className={styles.selected}>
          <BlueTick />
        </div>
      )}
      <div className={styles.avatar}>{option.label.charAt(0)}</div>
      <p className={styles.name}>{option.label}</p>
    </div>
  );
};

const SelectMulti = ({
  id,
  name,
  label,
  placeholder = "Select options",
  value = [],
  users = false,
  search = false,
  options = [],
  onChange,
  dropdownHeader = "",
  trackChanges = false,
  selectedTextPrefix = "",
  showSelectAll = true,
  selectAllText = "Select all options",
}) => {
  const selectContainerRef = useRef(null);
  const [selectedValues, setSelectedValues] = useState(value);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const getSelectedOptionObjects = () => {
    return options.filter((opt) => selectedValues.includes(opt.value));
  };

  const handleOptionSelect = (option) => {
    const isSelected = selectedValues.some((e) => e.value === option.value);
    const updatedValues = isSelected
      ? selectedValues.filter((e) => e.value !== option.value)
      : [...selectedValues, option];

    if (trackChanges) {
      onChange(updatedValues, { type: isSelected ? "remove" : "add", option });
    } else {
      onChange(updatedValues);
    }
  };

  const isOptionSelected = (option) => {
    return selectedValues.some((o) => o.value == option.value);
  };

  const displayText = () => {
    if (selectedValues.length === 0) {
      return placeholder;
    }

    return (
      <>
        {selectedTextPrefix ?? null}
        <span className={styles.selectedCountText}>
          {selectedValues.length} selected
        </span>
      </>
    );
  };

  const filteredOptions = options.filter((option) =>
    searchTerm.length > 0
      ? option.label.toLowerCase().includes(searchTerm.toLowerCase())
      : true,
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        selectContainerRef.current &&
        !selectContainerRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!dropdownOpen) {
      setSearchTerm("");
    }
  }, [dropdownOpen]);

  useEffect(() => {
    setSelectedValues(value);
  }, [value]);

  return (
    <div className={styles.multiSelectContainer} ref={selectContainerRef}>
      <label className={formBaseStyles.label} htmlFor={id}>
        {label}
      </label>
      <div
        className={`${formBaseStyles.input} ${styles.input}`}
        tabIndex={0}
        onClick={() => setDropdownOpen(!dropdownOpen)}
        onKeyUp={(e) => e.key === "Enter" && setDropdownOpen(!dropdownOpen)}
      >
        <p className={styles.inputSelection}>{displayText()}</p>

        <div className={`${styles.caret} ${dropdownOpen && styles.open}`}>
          <CaretDown />
        </div>
      </div>
      <div
        className={`${styles.dropdownContainer} ${dropdownOpen && styles.open}`}
      >
        {search && (
          <div className={styles.searchField}>
            <SearchIcon />
            <TextInput
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`${formBaseStyles.input} ${styles.searchInput}`}
            />
          </div>
        )}

        <div className={`${styles.dropdown}`}>
          {dropdownHeader && (
            <span className={styles.dropdownHeader}>{dropdownHeader}</span>
          )}

          {filteredOptions.length === 0 && (
            <div className={styles.option}>No options found</div>
          )}

          {filteredOptions.map((option) => (
            <Option
              key={option.value}
              option={option}
              handleOptionSelect={handleOptionSelect}
              selected={isOptionSelected(option)}
            >
              {users ? (
                <UserItem option={option} selected={isOptionSelected(option)} />
              ) : (
                <span
                  className={`${styles.multiSelectItem} ${isOptionSelected(option) && styles.selected}`}
                >
                  {isOptionSelected(option) && <BlueTick />}
                  {option.label}
                </span>
              )}
            </Option>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectMulti;
